import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FrontendMandant } from '@reflact/reflactportal';
import { LoginService } from 'src/app/shared/services/login.service';
import { LogtoService } from 'src/app/shared/services/logto.service';
import type { CloudFlight } from './cloud-flight';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false
})
export class LoginComponent implements AfterViewInit, OnDestroy {
  @ViewChild('cloudCanvas') private cloudCanvas?: ElementRef<HTMLCanvasElement>;
  public animationPaused = false;
  private cloudFlight?: CloudFlight;
  private destroyed = false;

  public message = ""
  public state: 'login' | 'mandant' = 'login';
  public mandants: FrontendMandant[] = []
  public mandant: string = "";

  constructor(public router: Router, public loginService: LoginService, private logtoService: LogtoService, private zone: NgZone) {
  }

  async ngAfterViewInit(): Promise<void> {
    try {
      const { CloudFlight } = await import('./cloud-flight');
      if (this.destroyed || !this.cloudCanvas) return;
      this.zone.runOutsideAngular(() => {
        this.cloudFlight = new CloudFlight(this.cloudCanvas!.nativeElement);
        this.cloudFlight.setPaused(this.animationPaused);
      });
    } catch {
      this.cloudFlight?.dispose();
    }
  }

  public toggleAnimation(): void {
    this.animationPaused = !this.animationPaused;
    this.zone.runOutsideAngular(() => this.cloudFlight?.setPaused(this.animationPaused));
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.cloudFlight?.dispose();
  }

  async ngOnInit() {
    const res = (await this.loginService.getTokenAndLogin());
    if (res.mandant != undefined && res.mandantUser != undefined) {
      this.router.navigate([""])
    }
  }

  public async selectMandant(mandant: FrontendMandant) {
    if (mandant == undefined) return
    const res = await this.loginService.selectMandant(mandant._id.toString());
    if (res.status == "ok") {
      this.router.navigate([""])
    }
  }

  public async signInWithLogto() {
    // baseURI resolves against the build's <base href> (/portal/de/, /portal/en/) so the
    // callback route matches wherever nginx actually serves this locale — not the domain root.
    await this.logtoService.signIn(new URL('callback', document.baseURI).toString());
  }
}
